module.exports = __webpack_public_path__ + "img/abacus_type_3 (old).7d047340.png";